import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "./AppBar";
import { Trans } from "react-i18next";
import { Container } from "@mui/material";
import { useHistory } from "react-router";
import LoadingButton from "../../../../../components/LoadingButton";
import { BuyProductView } from "@/react/Webshop/Components/Template/BuyProductView";
import { useBuyTemplateProduct } from "@/react/Webshop/hooks/useBuyTemplateProduct";
import useRetouch from "@/react/Webshop/hooks/useRetouch";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import ProductRetouch from "@/react/Webshop/Mobile/Pages/ProductRetouch/ProductRetouch";
import { useAddToCartUseBuyNow } from "@/react/Webshop/hooks/useAddToCartUseBuyNow";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& h2": {
      textAlign: "center",
    },
  },
  buttonContainer: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const history = useHistory();
  const { getRetouchPicturesByOrderLines } = useRetouch();
  const { hasRetouchProduct } = usePriceList();
  const [retouchPictures, setRetouchPictures] = useState(null);
  const useBuyNow = useAddToCartUseBuyNow();

  const buyProduct = useBuyTemplateProduct({
    onAddedToCart: (newOrderLines) => {
      if (hasRetouchProduct && newOrderLines && newOrderLines.length > 0) {
        const retouchPictures = getRetouchPicturesByOrderLines(newOrderLines);
        if (retouchPictures.length > 0) {
          setRetouchPictures(retouchPictures);
          return;
        }
      }
      history.push("/shopping-cart");
    },
  });

  if (retouchPictures !== null) {
    return <ProductRetouch pictures={retouchPictures} />;
  }

  return (
    <div className={classes.mainContainer}>
      <AppBar onCancel={() => changeMenu("main")} />

      <Container maxWidth={"sm"}>
        <h2>
          <Trans>Select quantity</Trans>
        </h2>

        <BuyProductView {...buyProduct} />
      </Container>

      <div className={classes.buttonContainer}>
        <LoadingButton
          isLoading={buyProduct.isUpdating}
          variant="primary"
          disabled={buyProduct.totalQuantity === 0}
          onClick={buyProduct.handleAddToCart}
        >
          {useBuyNow ? <Trans>Buy now</Trans> : <Trans>Add to cart</Trans>}
        </LoadingButton>
      </div>
    </div>
  );
};
